import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { MyHttpClient } from '../http-client.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentTransactionsService {
  constructor(private http: MyHttpClient) { }
  server = environment.server;
  getPaymentTransactionsURL = this.server + '/api/redeem/paymentTransactions';

  private handleError(error: HttpErrorResponse) {
    return throwError(error);
  }

  getPaymentTransactions(orderId: string, captainId: string) {
    const url = `${this.getPaymentTransactionsURL}/${orderId}`;
    const body = { captainId: captainId };
    
    return this.http.post(url, body).pipe(catchError(this.handleError));
  }
}
